import React from 'react';
import { isSameDate as defaultIsSameDate } from '../lib/helpers';

const WashingPage = ({
  barcodeInputRef,
  handleBlurToFocus,
  barcodeInput = '',
  setBarcodeInput,
  handleWashingScan,
  setCameraTargetField,
  setIsCameraOpen,
  washingSuccessList = [],
  washingErrorList = [],
  handleConfirmWashing,
  washingHistoryDate = '',
  setWashingHistoryDate,
  logs = [],
  isSameDate = defaultIsSameDate,
}) => {
  const checkSameDate = isSameDate || defaultIsSameDate;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
      <div style={{ background: '#fff', padding: '25px', borderRadius: '15px' }}>
        <h2>📥 รับคืนเข้าห้องล้าง (Basket Mode)</h2>
        <div style={{ display: 'flex', gap: '10px' }}>
          <input
            type="text"
            ref={barcodeInputRef}
            onBlur={handleBlurToFocus}
            value={barcodeInput}
            onChange={(e) => {
              if (setBarcodeInput) setBarcodeInput(e.target.value);
              if (e.target.value.length === 13 || e.target.value.length === 14) {
                if (handleWashingScan) handleWashingScan(e.target.value);
              }
            }}
            placeholder="สแกนรหัส 13 หรือ 14 หลัก... (ห้ามสแกนกล่อง)"
            style={{ flex: 1, padding: '15px', fontSize: '1.5em', border: '2px solid #795548', borderRadius: '8px' }}
            autoFocus
          />
          <button
            onClick={() => {
              if (setCameraTargetField) setCameraTargetField('main');
              if (setIsCameraOpen) setIsCameraOpen(true);
            }}
            style={{ padding: '0 20px', background: '#795548', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '1.8em' }}
          >
            📷
          </button>
        </div>
        <div style={{ display: 'flex', gap: '15px', marginTop: '20px' }}>
          <div style={{ flex: 1, border: '2px solid #27ae60', borderRadius: '10px', padding: '15px', minHeight: '300px', background: '#fafffa' }}>
            <h4 style={{ color: '#27ae60', marginTop: 0 }}>✅ พร้อมส่งคืน ({washingSuccessList.length})</h4>
            {washingSuccessList.map((item, i) => (
              <div key={i} style={{ borderBottom: '1px solid #ddd', padding: '8px 0', color: item.status === 'recalled' ? '#e74c3c' : 'inherit', fontWeight: item.status === 'recalled' ? 'bold' : 'normal' }}>
                {item.item_name} {item.status === 'recalled' ? <span>(⚠️ ถูกอายัด/เรียกคืน)</span> : <small>({item.location})</small>}
              </div>
            ))}
          </div>
          <div style={{ flex: 1, border: '2px solid #e74c3c', borderRadius: '10px', padding: '15px', minHeight: '300px', background: '#fffafa' }}>
            <h4>❌ ไม่ถูกต้อง</h4>
            {washingErrorList.map((err, i) => (
              <div key={i} style={{ borderBottom: '1px solid #fee', padding: '8px 0', color: '#c0392b' }}>
                {err.code}: {err.reason}
              </div>
            ))}
          </div>
        </div>
        <button
          onClick={handleConfirmWashing}
          disabled={washingSuccessList.length === 0}
          style={{
            width: '100%',
            marginTop: '20px',
            padding: '15px',
            background: '#27ae60',
            color: '#fff',
            border: 'none',
            borderRadius: '8px',
            fontSize: '1.2em',
            fontWeight: 'bold',
            cursor: washingSuccessList.length === 0 ? 'not-allowed' : 'pointer',
          }}
        >
          ยืนยันรับคืนทั้งหมด
        </button>
      </div>

      <div style={{ background: '#fff', padding: '25px', borderRadius: '15px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
        <h3>
          <span style={{ color: '#795548' }}>📜 ประวัติงานห้องล้าง</span>
          <input
            type="date"
            value={washingHistoryDate}
            onChange={(e) => setWashingHistoryDate && setWashingHistoryDate(e.target.value)}
            style={{ marginLeft: '10px', padding: '5px', border: '1px solid #ccc', borderRadius: '5px' }}
          />
        </h3>
        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.9em' }}>
            <thead>
              <tr style={{ background: '#f5f5f5', color: '#333' }}>
                <th style={{ padding: '10px', textAlign: 'left' }}>เวลา</th>
                <th style={{ padding: '10px', textAlign: 'left' }}>รายการ</th>
                <th style={{ padding: '10px', textAlign: 'left' }}>ดำเนินการ</th>
              </tr>
            </thead>
            <tbody>
              {logs
                .filter((l) => l.warehouse?.includes('ล้าง') && checkSameDate(l.timestamp, washingHistoryDate))
                .map((l) => (
                  <tr key={l.id} style={{ borderBottom: '1px solid #eee' }}>
                    <td style={{ padding: '10px' }}>{new Date(l.timestamp).toLocaleTimeString()}</td>
                    <td style={{ padding: '10px' }}>{l.item_name}</td>
                    <td style={{ padding: '10px', color: '#27ae60' }}>{l.action}</td>
                  </tr>
                ))}
              {logs.filter((l) => l.warehouse?.includes('ล้าง') && checkSameDate(l.timestamp, washingHistoryDate)).length === 0 && (
                <tr>
                  <td colSpan="3" style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
                    ยังไม่มีประวัติในวันที่เลือก
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default WashingPage;
